import React, {useState} from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography } from "@mui/material";
import {ReactComponent as Edit}from "../../../../../assets/images/edit.svg";
// import { useAlert } from "../../../../../context/AlertContext";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import styles from "./style";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../../components/CustomPagination";
import Modal from "../../../../../components/Modal";
import { useAlert } from "../../../../../context/AlertContext";


const CustomerList = ({data,page,setPage,total,handleDelete}) => {

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open,setOpen] = useState(false);
  const [value, setValue] = useState();
  const { showAlert } = useAlert();

  const deleteData = (item) => {
    setValue(item);

  }
  const handleDeleteItem = () => {
    handleDelete(value); // Call the delete function passed as prop
    setOpen(false); // Close the modal after deleting
  };


  const navigate = useNavigate()

  //   const handleNavigate = (item) => {
  //     navigate("/dashboard/supplierDetails", { state: { item } })
  //   }

  // const {showAlert} = useAlert();

  // const handleAlert = () =>{
  //   showAlert("Development In Progress","success");
  // }




  return (
    <>


      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>Email</TableCell>
              <TableCell sx={styles.TableHead}>Phone</TableCell>
              <TableCell sx={styles.TableHead}>Address</TableCell>
              {/* <TableCell sx={styles.TableHead}>Due</TableCell> */}
              <TableCell sx={styles.TableHead}>Action</TableCell>
              {/* <TableCell sx={styles.TableHead}>Action</TableCell> */}

            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (  
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : ( 
              data.map((item, index) => (  

                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src="" sx={{ mr: "8px" }} /><Box >
                      <Typography sx={styles.name}>{item?.name?.length > 20 ? `${item?.name.slice(0,20)}...` : item?.name}</Typography>
                      <Typography sx={styles.mail}></Typography>
                    </Box>       </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.email}</TableCell>
                  <TableCell sx={styles.tabledata}>+{item?.phone}</TableCell>
                  <TableCell sx={styles.tabledata}>{`${item?.billingAddress?.city}, ${item?.billingAddress?.country}`}</TableCell>
                  {/* <TableCell sx={styles.tabledata}></TableCell> */}
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
            
                      <Box sx={styles.editIcon}><Edit onClick={() => showAlert("Development In Progress", "success")}/> </Box>
                      {/* <Box sx={styles.editIcon}><Edit onClick={() => navigate("/dashboard/editCustomer",{state:{item}})}/> </Box> */}
                      <DeleteOutlineIcon sx={{ color: "#ff0000" }} onClick={() => { deleteData(item?._id),  setOpen(true);}}/>
                    </Box>

                  </TableCell>
                </TableRow>


              )))} 

          </TableBody>

        </Table>

        {data &&
       <CustomPagination
         pageCount={total}         
         page={page}
         setPage={setPage}
         rowsPerPage={rowsPerPage}
         setRowsPerPage={setRowsPerPage}
         totalItems={data.length}
       />} 

      </TableContainer>


      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Customers"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>    </>   );
};
export default CustomerList;
